import { Typography } from 'antd'
import { useTheme } from 'react-jss'

import { toPath } from '../routes'
import ButtonLink from './Common/ButtonLink'

const { Title } = Typography

function Error404() {
  const theme = useTheme()
  return (
    <main
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        background: theme.brandPrimary,
        color: 'white',
        textAlign: 'center',
        padding: '24px',
      }}
    >
      <div>
        <Title style={{ fontSize: '30vh', color: 'white' }}>404</Title>

        {/* At 0.4 the subtitle sat at 2.01:1 on the brand ground; 0.75 clears
            the 3:1 large-text threshold at 3.36:1. */}
        <Title level={2} style={{ opacity: 0.75, color: 'white' }}>
          Oops. Nothing here...
        </Title>

        {/* One control, not a button wrapping a link: ButtonLink renders the
            antd button as the anchor itself. */}
        <ButtonLink
          to={toPath.home()}
          style={{ marginTop: '40px', color: theme.brandPrimary }}
        >
          Go Home
        </ButtonLink>
      </div>
    </main>
  )
}

export default Error404
